import { render } from "./Wyswig.vue?vue&type=template&id=49c421f2&scoped=true"
import script from "./Wyswig.vue?vue&type=script&lang=js"
export * from "./Wyswig.vue?vue&type=script&lang=js"

import "./Wyswig.vue?vue&type=style&index=0&id=49c421f2&lang=scss&scoped=true"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c421f2"]])

export default __exports__